import { oc } from '@orpc/contract';
import { z } from 'zod';
export const CheckStatus = z.enum(['ok', 'degraded', 'fail']);
export const LivenessResponse = z.object({
    status: z.literal('ok'),
    version: z.string(),
});
export const ReadinessResponse = z.object({
    status: CheckStatus,
    version: z.string(),
    checks: z.object({
        db: CheckStatus,
        disk: CheckStatus,
        media: CheckStatus,
    }),
});
export const healthContract = {
    /** Процесс жив. Не трогает зависимости — для Docker healthcheck и liveness. */
    live: oc.route({ method: 'GET', path: '/health', summary: 'Liveness' }).output(LivenessResponse),
    /** Готовность обслуживать запросы: БД, свободное место, запись в media. */
    ready: oc
        .route({ method: 'GET', path: '/health/ready', summary: 'Readiness' })
        .output(ReadinessResponse),
};
//# sourceMappingURL=health.js.map